'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import CookieHandler from '../../personly-libs-cookie/src/index.js';
const CookiesContext = createContext(null);
const makeRequiredTypes = cookieTypes => cookieTypes.filter(({
  flags
}) => flags.isRequired).map(({
  handle
}) => handle);
const CookiesProvider = ({
  children,
  cookies,
  cookieTypes,
  hostname,
  consentName = 'consent'
}) => {
  const cookieHandler = useMemo(() => new CookieHandler(hostname, cookies), [hostname, cookies]);
  const getConsent = useCallback(() => {
    const types = makeRequiredTypes(cookieTypes);
    const data = cookieHandler.getCookie({
      createdAt: 0,
      types
    }, consentName);
    return data ? JSON.parse(data) : {
      types,
      createdAt: 0
    };
  }, [cookieHandler, cookieTypes, consentName]);
  const [consent, setConsent] = useState(getConsent());
  useEffect(() => {
    if (consent.createdAt === 0) return;
    const data_0 = JSON.stringify(consent);
    cookieHandler.setCookie(consent, consentName, data_0);
  }, [consent, consentName, cookieHandler]);
  const setCookie = useCallback((name, data_1) => cookieHandler.setCookie(consent, name, data_1), [consent, cookieHandler]);
  const getCookie = useCallback(name_0 => cookieHandler.getCookie(consent, name_0), [consent, cookieHandler]);
  const value = useMemo(() => ({
    setCookie,
    getCookie,
    setConsent,
    consent
  }), [setCookie, getCookie, setConsent, consent]);
  return _jsx(CookiesContext.Provider, {
    value: value,
    children: children
  });
};
function useCookies() {
  const context = useContext(CookiesContext);
  if (!context) {
    throw new Error("useCookies requires a context!");
  }
  return context;
}
export { CookiesProvider, useCookies };